import { getDraftSkills } from "./skill";
export const getProcesses = () => async (dispatch, getState) => {
  await dispatch(getDraftSkills({ page: -1 }));
  var data = getState().skillReducer.draft_skills;

  data = data.filter((skill) => skill.TEMPLATE !== "UserDocumentation");

  return {
    count: data.length,
    rows: data,
  };
};
